export const QUERY_KEYS = {
  POST: 'posts',
  COMMENTS: 'comments',
  REPLIES: 'replies', // 대댓글
  GAMES: 'games',
  POSTS: 'posts',
  SEARCH: 'search',
  DETAIL: 'detail',
  MEMOS: 'memos',
  AUTH: 'auth',
  USERINFO: 'userinfo',
  BOOKMARK: 'user_bookmarks',
  LIKE: 'user_likes'
};
